import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StateDistrictBlock, State,Block, District, Village  } from '../../data/types/stateDistrict';



const initialState: StateDistrictBlock = {
  states: [],
  districts: [],
  blocks: [],
  villages:[],
  loading: false,
  error: null,
};

export const stateDistrictSlice = createSlice({
  name: 'stateDistrictBlock',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading =false;
    },
    clearError: (state) => {
      state.error = null;
    },
    setStates: (state, action:PayloadAction<State[]>) => {
      state.states = action.payload;
      state.loading =false;
      state.error=null;
    },
    addState: (state, action) => {
      state.states.push(action.payload);
    },
    updateState: (state, action) => {
      const index = state.states.findIndex((s) => s.id === action.payload.id);
      if (index !== -1) {
        state.states[index] = action.payload;
      }
    },
    // deleteState: (state, action) => {
    //   state.states = state.states.filter((s) => s.id !== action.payload);
    // },
    setDistricts: (state, action:PayloadAction<District[]>) => {
      state.districts = action.payload;
      state.loading=false;
      state.error=null;
    },
    addDistrict: (state, action) => {
      state.districts.push(action.payload);
    },
    updateDistrict: (state, action) => {
      const index = state.districts.findIndex((d) => d.id === action.payload.id);
      if (index !== -1) {
        state.districts[index] = action.payload;
      }
    },
   deleteDistrict: (state, action: PayloadAction<number>) => {
      state.districts = state.districts.filter((d) => d.id !== action.payload);
      state.blocks = state.blocks.filter((b) => b.districtId !== action.payload);
      state.loading = false;
      state.error = null;
    },
    setBlocks: (state, action:PayloadAction<Block[]>) => {
      state.blocks = action.payload;
       state.loading=false;
      state.error=null;
    },
    addBlock: (state, action) => {
      state.blocks.push(action.payload);
    },
    updateBlock: (state, action) => {
      const index = state.blocks.findIndex((b) => b.id === action.payload.id);
      if (index !== -1) {
        state.blocks[index] = action.payload;
      }
    },
   deleteBlock: (state, action: PayloadAction<number>) => {
      state.blocks = state.blocks.filter((b) => b.id !== action.payload);
      state.loading = false;
      state.error = null;
    },
     setVillages: (state, action:PayloadAction<Village[]>) => {
      state.villages = action.payload;
       state.loading=false;
      state.error=null;
    },
    addVillages: (state, action) => {
      state.villages.push(action.payload);
    },
    updateVillages: (state, action) => {
      const index = state.villages.findIndex((b) => b.id === action.payload.id);
      if (index !== -1) {
        state.villages[index] = action.payload;
      }
    },
   deleteVillages: (state, action: PayloadAction<number>) => {
      state.villages = state.villages.filter((b) => b.id !== action.payload);
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  setLoading,
  setError,
  clearError,
  setStates,
  addState,
  updateState,
//   deleteState,
  setDistricts,
  addDistrict,
  updateDistrict,
  deleteDistrict,
  setBlocks,
  addBlock,
  updateBlock,
  deleteBlock,
  setVillages,
  addVillages,
  updateVillages,
  deleteVillages
} = stateDistrictSlice.actions;

export default stateDistrictSlice.reducer;